<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="商品：" prop="goodsId">
            <el-select style="width: 420px;" v-model="ruleForm.goodsId" placeholder="请选择商品">
              <el-option v-for="(item,index) in goodsList" :key="index" :label="item.goodsName" :value="item.goodsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.activeGoodsSpecList.length > 0" label="规格：" prop="activeGoodsSpecList">
            <el-table
              :data="ruleForm.activeGoodsSpecList"
              border
              style="width: 100%">
              <el-table-column
                prop="goodsSpecName"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="goodsSpecThumb"
                label="图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 32px;"
                    :src="scope.row.goodsSpecThumb"
                    :preview-src-list="[scope.row.goodsSpecThumb]"
                    fit="contain"></el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiSpecPrice"
                label="售价">
              </el-table-column>
              <el-table-column
                prop="apiStockNum"
                label="库存">
              </el-table-column>
              <el-table-column
                prop="apiWeight"
                label="重量(kg)">
              </el-table-column>
              <el-table-column
                prop="volume"
                label="体积(m³)">
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="购买限制：" prop="buyLimit">
            <el-input style="width: 424px;" v-model="ruleForm.buyLimit" placeholder="请输入购买限制（个），默认0，为不限制"></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveActiveGoods, updateActiveGoods, fetchActiveGoodsDetailById, queryAllEnableGoodsList } from '@/api/activity'
export default {
  name: 'ActivityGoodsAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      goodsList: [],
      ruleForm: {
        goodsId: '',
        activeGoodsSpecList:[],
        buyLimit:'',
        sort: '',
        status: false
      },
      rules: {
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        activeGoodsSpecList: [
          { required: true, message: '请完成规格', trigger: 'blur' }
        ]
      },
      isOne:1
    }
  },
  watch: {
    'ruleForm.goodsId': {
      handler(newVal, oldVal) {
        var that = this;
        if(that.dataId == '' || (that.dataId != '' && that.isOne == 2)){
          that.goodsList.forEach(function(item){
            if(newVal == item.goodsId){
              that.ruleForm.activeGoodsSpecList = item.activeGoodsSpecPageVoList;
            }
          });
        }
        that.isOne = 2;
      }
    }
  },
  mounted () {
    this.goodsFun();
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      fetchActiveGoodsDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.goodsId = data.goodsId
          that.ruleForm.goodsName = data.goodsName
          that.ruleForm.activeGoodsSpecList = data.activeGoodsSpecPageVoList;
          that.ruleForm.buyLimit = data.buyLimit
          that.ruleForm.sort = data.sort
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 商品列表数据
    goodsFun(){
      let that = this
      queryAllEnableGoodsList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.goodsList = data;
        }
      })
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let goodsId = that.ruleForm.goodsId
      let buyLimit = that.ruleForm.buyLimit
      var activeGoodsSpecList = that.ruleForm.activeGoodsSpecList
      var ids = [];
      activeGoodsSpecList.forEach(function(item){
        ids.push(item.goodsSpecId)
      });
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (goodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      let passData = {
        goodsId: goodsId,goodsSpecIdList:ids,buyLimit:buyLimit,status:status,sort:sort
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateActiveGoods(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveActiveGoods(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/activity/GoodsAdd.vue